import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { CustomerGroupForm } from '../-customer-group-form'

export const Route = createFileRoute('/_authenticated/_general/customer-groups/$customerGroupUuid/edit')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.CustomerGroups.EditTitle()
	}
})

function RouteComponent() {
	const { customerGroupUuid } = Route.useParams()
	return (
		<RouteModal
			asDrawer
			requiresData
			loader={async api => await api.getCustomerGroup({ path: { customerGroupUuid } })}
		>
			{data => <CustomerGroupForm group={data} />}
		</RouteModal>
	)
}
